module.exports = __webpack_public_path__ + "img/ESKO.0dde759f.jpg";